import { render } from "./ReviewSearchFilter.vue?vue&type=template&id=1c8aafdd&scoped=true"
import script from "./ReviewSearchFilter.vue?vue&type=script&lang=js"
export * from "./ReviewSearchFilter.vue?vue&type=script&lang=js"

import "./ReviewSearchFilter.vue?vue&type=style&index=0&id=1c8aafdd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8aafdd"]])

export default __exports__